import request from './request';

// ---------------------- 用户信息 ----------------------
//获取menu列表
function getMenus() {
    return request({
        url: '/sys/permission/menu/tree/',
        method: 'get',
    })
}

//获取用户信息
function getUserInfo() {
    return request({
        url: '/sys/user/info/',
        method: 'get',
    })
}

//获取菜单
function getMenuOfPersonal() {
    return request({
        url: '/sys/get_personal_menu',
        method: 'get',
    })
}

//用户退出
function logout(redirect) {
    return request({
        url: `/sys/logout`,
        method: 'post',
        data: {
            redirect
        }
    })
}

//用户登录
function login(ticket, redirect) {
    return request({
        url: `/sys/login/`,
        method: 'get',
        params: {
            redirect,
            ticket
        }
    })
}

// ---------------------- 通知 ----------------------
//获取全部通知
function getNotices(page, page_size) {
    return request({
        url: `common/get_notice_list`,
        method: 'get',
        params: {
            page,
            page_size
        }
    })
}

//获取未读通知
function getUnreadNotices(page, page_size) {
    return request({
        url: `common/get_unread_notice`,
        method: 'get',
        params: {
            page,
            page_size
        }
    })
}

//消息修改已读状态接口
function setReadNotices() {
    return request({
        url: `common/put_notice_flag?spread=all`,
        method: 'put',
    })
}

//删除系统消息
function deleteNotices() {
    return request({
        url: `common/delete_notice?spread=read`,
        method: 'delete',
    })
}

// ---------------------- 日志 ----------------------

//获取更新日志
function getUpdateLogList(page, page_size) {
    return request({
        url: '/sys/log/updates',
        method: 'get',
        params: {
            page,
            page_size
        }
    })
}

// ---------------------- 企业 ----------------------

//获取企业列表
function getEnterprise(include_indiv_org) {
    return request({
        url: 'sys/comp/switch/',
        method: 'get',
        params: {
            include_indiv_org
        }
    })
}

//切换 企业
function switchEnterprise(co_id) {
    return request({
        url: 'sys/comp/switch/',
        method: 'put',
        data: {
            co_id
        }
    })
}

//修改企业名称
function editCompName(data) {
    return request({
        url: 'sys/comp/name',
        method: 'put',
        data
    })
}

// ---------------------- 订阅权限 ----------------------

//获取 是否授权
function getLicenseValid() {
    return request({
        url: 'sys/get_license_valid',
        method: 'get',
    })
}

//获取订阅方案
function getLicense(prd_code) {
    return request({
        url: `sys/subs_plan/simple_info?prd_code=${prd_code}`,
        method: 'get',
    })
}

//获取管理员
function getAdmins() {
    return request({
        url: 'sys/get_com_user_administrator',
        method: 'get',
    })
}

// ---------------------- 其他 ----------------------

//主体核查功能简介图片
function getSuspectPic() {
    return request({
        url: `/pm/info/suspect/suspect_pic`,
        method: 'get',
    })
}

//获取核查记录
function getCheckList(params) {
    return request({
        url: `/check`,
        method: 'get',
        params
    })
}

//获取首页核查 筛选框枚举
function getCheckEnums(params) {
    return request({
        url: `/check/enums`,
        method: 'get',
        params
    })
}

//获取核查网站列表
function getCheckWebsiteList() {
    return request({
        url: `/check/website`,
        method: 'get'
    })
}

//获取核查对象 解析接口
function getVerifyTheCompanyByFile(data) {
    return request({
        url: `/check/upload`,
        method: 'put',
        data
    })
}

//获取核查对象->上传文件
function getVerifyTheCompany(data) {
    return request({
        url: `/check/parse`,
        method: 'post',
        data
    })
}

//获取消耗的核查权益点
function obtainConsumption(data) {
    return request({
        url: `/check/opm/estimate`,
        method: 'post',
        data
    })
}

//创建核查
function createVerify(data) {
    return request({
        url: `/check`,
        method: 'post',
        data
    })
}

//删除核查
function deleteVerify(task_ids) {
    return request({
        url: `/check`,
        method: 'delete',
        data: {
            task_ids
        }
    })
}

//获取常用网站
function getFrequentlyWebsite() {
    return request({
        url: `/check/frequently_website`,
        method: 'get',

    })
}

//创建常用网站
function addFrequentlyWebsite(data) {
    return request({
        url: `/check/frequently_website`,
        method: 'post',
        data
    })
}

//删除常用网站
function deleteFrequentlyWebsite(id) {
    return request({
        url: `/check/frequently_website/${id}`,
        method: 'delete',
    })
}

// 终止/启动核查项目
function handleTask(id, status) {
    return request({
        url: `/check/${id}`,
        method: 'put',
        data: {
            status
        }
    })
}

//获取核查记录 核查对象列表
function getTaskObjectsList(id) {
    return request({
        url: `/check/objs/${id}`,
        method: 'get',
    })
}

//获取核查记录 核查详情
function getTaskInfo(id, target_name, company, id_card, area) {
    return request({
        url: `/check/${id}`,
        method: 'get',
        params: {
            target_name,
            company: company || undefined,
            id_card: id_card || undefined,
            area: area || undefined
        }
    })
}

//重试核查报告某个网站
function retryVerification(id, crawler_id) {
    return request({
        url: `/check/once/${id}?crawler_id=${crawler_id}`,
        method: 'put',
    })
}

//批量重试核查报告某个网站
function retryAllVerification(id, params) {
    return request({
        url: `/check/batch_re/${id}`,
        method: 'get',
        params
    })
}

//获取 定时任务列表
function getCronCheckList(params) {
    return request({
        url: `/check/cron`,
        method: 'get',
        params
    })
}

//删除定时任务
function deleteCronVerify(task_ids) {
    return request({
        url: `/check/cron`,
        method: 'delete',
        data: {
            task_ids
        }
    })
}

//修改定时任务
function editCronVerify(params) {
    return request({
        url: `/check/cron/${params.id}`,
        method: 'put',
        data: params
    })
}

//获取任务配置项
function getCheckSettingInfo(params) {
    return request({
        url: `/check/info`,
        method: 'get',
        params
    })
}

//获取图片列表
function getCheckImagesPaths(params) {
    return request({
        url: `/check/paths`,
        method: 'get',
        params
    })
}

//获取对应网站列表
function getCheckWebsList(params) {
    return request({
        url: `/check/websites`,
        method: 'get',
        params
    })
}


//查询核查网站列表
function getWebsite(params) {
    return request({
        url: `/website`,
        method: 'get',
        params
    })
}

//获取网站管理页 筛选框枚举
function getWebsiteEnums(params) {
    return request({
        url: `/website/enums`,
        method: 'get',
        params
    })
}

// 修改网站设置
function handleWebsite(id, data) {
    return request({
        url: `/website/${id}`,
        method: 'put',
        data
    })
}

// 删除网站
function deleteWebsite(id) {
    return request({
        url: `/website/${id}`,
        method: 'delete',
    })
}

//添加网站
function addWebsite(id , params) {
    return request({
        url: `/website`,
        method: 'post',
        params
    })
}

//上传图片获取链接
function uploadImages(data) {
    return request({
        headers: {
            'Content-Type': 'multipart/form-data;'
        },
        url: `/check/upload_check`,
        method: 'put',
        data
    })
}

//保存截图文件
function saveCheckFile(data) {
    return request({
        url: `/check/files/save`,
        method: 'post',
        data
    })
}

//下载报告
function downloadReport(params) {
    return request({
        url: `report/report`,
        method: 'get',
        // responseType: 'arraybuffer',
        params
    })
}

//获取下载报告tips
function getDownloadTips(params) {
    return request({
        url: `report/zip-tips`,
        method: 'get',
        // responseType: 'arraybuffer',
        params
    })
}

//下载报告文件
function downloadReportFile(params) {
    return request({
        url: `report/download`,
        method: 'get',
        responseType: 'arraybuffer',
        params
    })
}

//获取报告状态
function getReportStatus(check_id) {
    return request({
        url: `/report/status?check_id=${check_id}`,
        method: 'get',
    })
}

//重试报告状态
function retryReportStatus(check_id) {
    return request({
        url: `/report/generate`,
        method: 'post',
        data:{
            check_id
        }
    })
}

//获取核查数量
function getCheckNumber() {
    return request({
        url: `/check/view/count`,
        method: 'get',
    })
}

//获取权益点
function getEquityPointsFunc() {
    return request({
        url: `/check/opm/info`,
        method: 'get',
    })
}

//查询账号列表
function getAccountList(params) {
    return request({
        url: `/website/account`,
        method: 'get',
        params
    })
}

//查询可选网站列表
function getAccountWebsiteOptions(params) {
    return request({
        url: `/website/account/options`,
        method: 'get',
        params
    })
}

//验证账号密码
function verifyAccountPassword(data) {
    return request({
        url: `/website/account/verify`,
        method: 'post',
        data
    })
}

//新增/编辑网站账号
function saveAccount(data) {
    return request({
        url: `/website/account`,
        method: 'post',
        data
    })
}

//获取密码
function getAccountPassword(id) {
    return request({
        url: `/website/account/${id}/password`,
        method: 'get',
    })
}

//删除账号
function deleteAccount(id) {
    return request({
        url: `/website/account/${id}`,
        method: 'delete',
    })
}
export default {
    getMenus,
    getUserInfo,
    logout,
    login,
    getMenuOfPersonal,
    getUnreadNotices,
    getNotices,
    setReadNotices,
    deleteNotices,
    getUpdateLogList,
    getEnterprise,
    switchEnterprise,
    getLicenseValid,
    getAdmins,
    editCompName,
    getLicense,
    getSuspectPic,
    getCheckList,
    getCheckWebsiteList,
    getVerifyTheCompany,
    createVerify,
    getCheckEnums,
    deleteVerify,
    getFrequentlyWebsite,
    addFrequentlyWebsite,
    deleteFrequentlyWebsite,
    handleTask,
    getTaskObjectsList,
    getTaskInfo,
    getCronCheckList,
    deleteCronVerify,
    getCheckSettingInfo,
    editCronVerify,
    getVerifyTheCompanyByFile,
    getCheckImagesPaths,
    getCheckWebsList,
    retryVerification,
    getWebsite,
    getWebsiteEnums,
    handleWebsite,
    deleteWebsite,
    addWebsite,
    uploadImages,
    saveCheckFile,
    downloadReport,
    getDownloadTips,
    getReportStatus,
    retryReportStatus,
    downloadReportFile,
    getCheckNumber,
    retryAllVerification,
    getEquityPointsFunc,
    obtainConsumption,
    getAccountList,
    getAccountWebsiteOptions,
    verifyAccountPassword,
    saveAccount,
    getAccountPassword,
    deleteAccount
}